import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { getUser } from '../../../auth/state/selectors';
import { User } from '../../../models/User';
import { GetPracticeStaff } from '../../../practices/state/actions';
import { getPracticeStaff } from '../../../practices/state/selectors';
import { AppState } from '../../../state/reducers';
import { isEmbedMode } from '../../../state/selectors';

@Component({
  selector: 'watchers',
  templateUrl: './watchers.component.html',
  styleUrls: ['./watchers.component.scss']
})
export class WatchersComponent implements OnInit, OnChanges, OnDestroy {
  alive = true;
  @Input() watchers: User[] | undefined = [];
  @Output() watch = new EventEmitter<User>();
  @Output() unwatch = new EventEmitter<User>();
  flyoutOpen = false;
  authUser$?: Observable<User | null>;
  allUsers$?: Observable<User[]>;
  filteredUsers$ = new BehaviorSubject<User[]>([]);
  filteredUsers: User[] = [];
  allUsers: User[] = [];
  authUser?: User | null;
  embedMode$?: Observable<boolean>;
  embedMode?: boolean;

  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
    this.subscribeToAuthUser();
    this.subscribeToPracticeStaff();
    this.subscribeToEmbedMode();
  }

  ngOnChanges(): void {
    this.filteredUsers = this.allUsers.filter(user => !this.watchers?.map(watcher => watcher.id).includes(user.id));
    this.filteredUsers$.next(this.filteredUsers);
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  subscribeToAuthUser(): void {
    this.authUser$ = this.store.pipe(select(getUser)).pipe(takeWhile(() => this.alive));
    this.authUser$.subscribe((authUser) => {
      this.authUser = authUser;
      this.store.dispatch(GetPracticeStaff());
    });
  }

  subscribeToPracticeStaff(): void {
    this.allUsers$ = this.store.pipe(select(getPracticeStaff)).pipe(takeWhile(() => this.alive));
    this.allUsers$.subscribe(users => {
      this.allUsers = users;
      this.filteredUsers = users.filter(user => !this.watchers?.map(watcher => watcher.id).includes(user.id));
      this.filteredUsers$.next(this.filteredUsers);
    });
  }

  subscribeToEmbedMode(): void {
    this.embedMode$ = this.store
      .pipe(select(isEmbedMode));

    this.embedMode$.subscribe(embedMode => this.embedMode = embedMode)
  }

  openFlyout(): void {
    this.flyoutOpen = true;
  }

  closeFlyout(): void {
    this.flyoutOpen = false;
  }

  handleClickOutside(): void {
    if (this.flyoutOpen) {
      this.closeFlyout();
    }
  }

  handleWatch(user: User): void {
    this.watch.emit(user);
  }

  handleUnwatch(user: User): void {
    this.unwatch.emit(user);
  }

  handleFlyoutClick(event: Event): void {
    if ((event.target as HTMLElement).classList.contains('flyout')) {
      this.closeFlyout();
    }
  }

  authUserIsWatching(): boolean {
    if (this.authUser && this.watchers?.find((w) => w.id === this.authUser?.id)) {
      return true;
    }

    return false;
  }
}
